module.exports = "<button class=\"Button Button--fullWidth Button--icon Button--join Button--large\" ng-class=\"ctrl.options.cssClass\" ng-disabled=\"ctrl.isLoadingScript\">\n  <div class=\"Join-loader\" ng-if=\"ctrl.isLoadingScript\">\n    <div class=\"Loader\"></div>\n  </div>\n  <span><i class=\"Icon\" ng-class=\"ctrl.options.iconCssClass\"></i></span>\n  Connect with {{ctrl.options.displayName}}\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/join/join_option_button.html
// module id = 534
// module chunks = 24